import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import { MaterialReactTable } from 'material-react-table';
import LeadService from '../../../core/services/leadsService';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import toast from 'react-hot-toast';
import Pagination from '@mui/material/Pagination';
import { format } from 'date-fns';
import { debounce, throttle } from 'lodash';
import { styled, Dialog, TextField, InputAdornment, Box } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import CreateSaleAgent from './CreateSaleAgent';
const useStyles = makeStyles((theme) => ({
    LeadTable: {
        overflowX: 'auto',
        width: 'auto',
        borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    SuperAdminIcaContainer: {
        [theme.breakpoints.down('md')]: {
            width: '1000px',
            margin: '0 auto',
        },
    },
}));

const GetSalesAgents = () => {
    const classes = useStyles();
    const theme = useTheme();


    const [saleAgents, setSaleAgents] = React.useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const abortControllerRef = useRef(null);
    const [logOutModal, setLogOutModal] = React.useState(false);


    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const adjustTimeBasedOnOffsetForReceivedDataPaymentsDate = (dateString, offsetInHours) => {
        // Ensure the date string is treated as UTC by appending 'Z'
        const date = new Date(`${dateString}Z`);

        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 20,
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 20,
            enableSorting: false,

        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 150,
            muiTableHeadCellProps: {
                align: 'left',
            },
        },

        {
            accessorKey: 'email',
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            // enableClickToCopy: true,
            size: 100,
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableSorting: false,
            enableColumnFilter: false,
            size: 100,
        },
        {
            accessorKey: 'subscription_type',
            header: 'Subscription Type',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const subscriptionType = row?.original?.subscription_type;
                const capitalFirstLetter = (type) => {
                    switch (type) {
                        case 'premier':
                            return 'Premier';
                        case 'elite':
                            return 'Elite';
                        case 'founder':
                            return 'Founder';
                        default:
                            return 'Unknown';
                    }
                };
                return <span>{capitalFirstLetter(subscriptionType ? subscriptionType : 'Not Subscribed')}</span>;
            },
        },

        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'deleted_at',
            header: 'Deleted at',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.deleted_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'trial_start_at',
            header: 'Trail Start',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trial_start_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'userLastPayment',
            header: 'Last Payment',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.userLastPayment;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'userExpiryPayment',
            header: 'Expire Payment',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.userExpiryPayment;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },

        {
            accessorKey: 'last_login',
            header: 'Last Login',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return "Never Logged In";
            },
        },

    ], [navigate]);

    const SalesAgents = async (currentPage, searchTerm = '', signal) => {
        try {
            setIsLoading(true)
            const res = await LeadService.getSalesAgents(currentPage, searchTerm, { signal });
            if (res?.data?.success) {
                setSaleAgents(res?.data?.agents?.data);
                setCurrentPage(res?.data?.agents?.current_page);
                setTotalPages(Math.ceil(res?.data?.agents?.total / res?.data?.agents.per_page));
                return;
            }

        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);

        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledSalesAgents = useCallback(
        throttle((page, searchTerm, signal) => {
            SalesAgents(page, searchTerm, signal);
        }, 2000), []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchSalesAgents = useCallback(
        debounce((page, searchTerm) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledSalesAgents(page, searchTerm, abortController.signal);
        }, 300), [throttledSalesAgents]
    );

    useEffect(() => {
        fetchSalesAgents(currentPage, searchTerm);
    }, [currentPage, searchTerm, fetchSalesAgents]);

    const handleClear = () => {
        setSearchTerm('');
        setCurrentPage(1);
        fetchSalesAgents(1, '');
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoading && <LinearProgress />}</div>
            <div
                className={classes.SuperAdminIcaContainer}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                    <div>
                        <Typography style={{ fontSize: '36px', fontWeight: '700' }} className="services-animated-text">Sale Agents</Typography>
                    </div>

                </div>
                <div style={{ width: '100%', overflow: 'visible' }}>
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', gap: '10px' }}>
                        <CreateSaleAgent SalesAgents={SalesAgents} />
                    </Box>

                    <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', gap: '10px' }}>
                        <TextField
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClear}
                                            aria-label="clear search"
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            sx={{
                                width: 320, '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                        />

                    </Box>
                    <ThemeProvider theme={theme}>
                        <GlobalStyles
                            styles={{
                                '::-webkit-scrollbar': {
                                    width: '14px', // Set the desired width for the scrollbar
                                },
                                '::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                    borderRadius: '10px', // Set the border radius for a rounded effect
                                },
                            }}
                        />
                        <div className={classes.LeadTable}>
                            <MaterialReactTable
                                columns={columns}
                                data={saleAgents}
                                state={{ isLoading: isLoading }}
                                muiCircularProgressProps={{
                                    color: 'secondary',
                                    thickness: 5,
                                    size: 55,
                                }}
                                muiSkeletonProps={{
                                    animation: 'pulse',
                                    height: 28,
                                }}
                                enablePagination={false}
                                enableTopToolbar={true}
                                enableDensityToggle={false}
                                enableHiding={false}
                                showSkeletons={false}
                                // enableRowSelection={(row) => {
                                //     return !row?.original?.deleted_at;
                                // }}
                                // onRowSelectionChange={setRowSelection}
                                // getRowId={(row) => row?.id}
                                enableColumnFilterModes={false}
                                enableColumnActions={false}
                                enableColumnOrdering={false}
                                enableFullScreenToggle={false}
                                enableColumnFilters={false}
                                enableGlobalFilter={false}
                                initialState={{
                                    showColumnFilters: false,
                                    showGlobalFilter: false,
                                }}

                                muiTableBodyRowProps={{
                                    sx: {
                                        backgroundColor: '#f5f5f5', // Default row background color
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: '#ffffff', // Alternate rows with white
                                        },
                                        '&:hover': {
                                            backgroundColor: '#e0e0e0', // Hover effect
                                            cursor: 'pointer'
                                        },
                                    },
                                }}
                            />
                        </div>
                    </ThemeProvider>

                    <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                    />
                </div>
            </div>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </>
    );
};

export default GetSalesAgents;
